import { forwardRef, useCallback, useRef, type HTMLAttributes } from 'react';

import { SkeletonScope, useSkeletonRef, type SkeletonGroupAnimation } from '../skeleton/motion';

export interface SkeletonGroupProps extends HTMLAttributes<HTMLDivElement> {
  animation?: SkeletonGroupAnimation;
  animated?: boolean;
}

export const SkeletonGroup = forwardRef<HTMLDivElement, SkeletonGroupProps>(function SkeletonGroup(
  { animation, animated, children, ...props },
  ref,
) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const receive = useCallback((element: HTMLDivElement | null) => {
    containerRef.current = element;
  }, []);
  const mergedRef = useSkeletonRef(receive, ref);
  return (
    <SkeletonScope
      animation={animation}
      animated={animated}
      independent
      containerRef={containerRef}
    >
      <div {...props} ref={mergedRef}>
        {children}
      </div>
    </SkeletonScope>
  );
});

export type { SkeletonAnimation, SkeletonGroupAnimation } from '../skeleton/motion';
